import {Button, Spinner, tokens, css} from '@sail/ui';
import {useTheme} from '../ThemeProvider';

interface BrandedPrimaryButtonProps {
  onPress: () => void;
  disabled?: boolean;
  pending?: boolean;
  dataTestId?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

export function SendUsAnEmailSubmitButton({
  onPress,
  disabled,
  pending,
  dataTestId,
  children,
  size = 'large',
}: BrandedPrimaryButtonProps) {
  const theme = useTheme();

  return (
    <Button
      size={size}
      key="button"
      onPress={onPress}
      disabled={disabled}
      data-testid={dataTestId}
      css={{width: 'fill'}}
      uses={[
        disabled
          ? css({
              backgroundColor: tokens.color.neutral[50],
              boxShadow: 'none',
              color: 'form.disabled',
              '::after': {
                display: 'none',
              },
            })
          : css({
              backgroundColor: theme.primaryActionColor,
              color: 'white',
              borderColor: theme.primaryActionColor,
              ':hover:not(:active):not([aria-disabled="true"])': {
                backgroundColor: theme.primaryActionColor,
                keyline: theme.ctaHoverColor,
                topShadow: theme.primaryActionColor,
                color: 'white',
              },
              ':active:not([aria-disabled="true"])': {
                topShadow: theme.pressedShadow,
                backgroundColor: theme.primaryActionColor,
                keyline: theme.primaryActionColor,
                color: 'white',
              },
            }),
      ]}
    >
      {pending ? <Spinner /> : children}
    </Button>
  );
}
